import React from 'react';
import {Grid, Box, useMediaQuery, Theme} from '@mui/material';

import Welcome from './Welcome';
import {Logo} from '../layout/Logo';

const DefaultDashboard = () => {
    const isXSmall = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down('sm')
    );
    const isSmall = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down('lg')
    );

    return isXSmall ? (
        <Grid container spacing={1}>
            <Box ml={1}>
                <Logo/>
            </Box>
            <Grid item xs={12}>
                <Welcome/>
            </Grid>
        </Grid>
    ) : isSmall ? (
        <Grid container spacing={2} padding={1}>
            <Box mt={1} ml={1} display="flex">
                <Logo/>
            </Box>
            <Grid item xs={12}>
                <Welcome/>
            </Grid>
        </Grid>
    ) : (
        <Grid container spacing={2} padding={1}>
            <Box mt={2} ml={-3} display="flex">
                <Logo/>
            </Box>
            <Grid item xs={12}>
                <Welcome/>
            </Grid>
        </Grid>
    );
};

export default DefaultDashboard;
